export default __webpack_public_path__ + "static/media/ARPHICPL.3aa73261.TXT";